module.exports = __webpack_public_path__ + "static/media/X_TIBET.b16ecfd2.svg";